import React, { useState, useContext, useEffect } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import ProfileContent from 'components/Profile/ProfileContent';
import { Grid } from '@mui/material';
import BillingOverview from 'pages/billing/BillingOverview';
import PlansOverview from 'pages/plans/PlansOverview';
import TeamContent from 'components/Profile/TeamContent';
import { Link } from 'react-router-dom';
import Affiliations from 'pages/affiliations/Affiliations';

const ProfileHome: React.FC = (props: any) => {
  const { cur_user } = useContext(GlobalContext);
  const savedTab = window.sessionStorage.getItem('activeTab');
  const [ activeTab, setActiveTab ] = useState<string>('');
  const [ customerId, setCustomerId ] = useState<any>('');

  const getMatchedCusId = () => {
    cur_user.stripe_cus_info.map((cus: any) => {
      if (cus.name === cur_user.selected_team.name) {
        setCustomerId(cus.id);
      }
    });
  };

  useEffect(() => {
    getMatchedCusId();
  }, []);


  const handleTabChange = (tab: string) => {
    switch (tab) {
    case 'Profile':
      setActiveTab('Profile');
      window.sessionStorage.setItem('activeTab', 'Profile');
      break;
    case 'Team':
      setActiveTab('Team');
      window.sessionStorage.setItem('activeTab', 'Team');
      break;
    case 'Affiliations':
      setActiveTab('Affiliations');
      window.sessionStorage.setItem('activeTab', 'Affiliations');
      break;
    case 'Plans':
      setActiveTab('Plans');
      window.sessionStorage.setItem('activeTab', 'Plans');
      break;
    case 'Billing':
      setActiveTab('Billing');
      window.sessionStorage.setItem('activeTab', 'Billing');
      break;
    case 'Notifications':
      setActiveTab('Notifications');
      window.sessionStorage.setItem('activeTab', 'Notifications');
      break;
    default:
      setActiveTab('Profile');
    }
  };

  useEffect(() => {
    if (props.location.state) {
      const { linkTab } = props.location.state;
      setActiveTab(linkTab);
      window.sessionStorage.setItem('activeTab', linkTab);
    } else if (savedTab) {
      setActiveTab(savedTab);
    }
  }, []);

  return (
    <section className='home-content-body Home-HeaderDown' style={{ minHeight: 0 }} >
      <Grid container>
        <Grid item xs={12}>
          <div className='module-header'>
            <div className='module-header-breadcrumbs'>
              <Link to='/'>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' cursor={'pointer'}>
                  <path d='M7.5 17.5V11.3333C7.5 10.8666 7.5 10.6333 7.59083 10.455C7.67072 10.2982 7.79821 10.1707 7.95501 10.0908C8.13327 9.99999 8.36662 9.99999 8.83333 9.99999H11.1667C11.6334 9.99999 11.8667 9.99999 12.045 10.0908C12.2018 10.1707 12.3293 10.2982 12.4092 10.455C12.5 10.6333 12.5 10.8666 12.5 11.3333V17.5M9.18141 2.30333L3.52949 6.69927C3.15168 6.99312 2.96278 7.14005 2.82669 7.32405C2.70614 7.48704 2.61633 7.67065 2.56169 7.86588C2.5 8.08627 2.5 8.32558 2.5 8.80421V14.8333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1585 3.41002 17.3183C3.76654 17.5 4.23325 17.5 5.16667 17.5H14.8333C15.7668 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1585 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V8.80421C17.5 8.32558 17.5 8.08627 17.4383 7.86588C17.3837 7.67065 17.2939 7.48704 17.1733 7.32405C17.0372 7.14005 16.8483 6.99312 16.4705 6.69927L10.8186 2.30333C10.5258 2.07562 10.3794 1.96177 10.2178 1.918C10.0752 1.87938 9.92484 1.87938 9.78221 1.918C9.62057 1.96177 9.47418 2.07562 9.18141 2.30333Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </Link>
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <path d='M6 12L10 8L6 4' stroke='#D0D5DD' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
              <Link to='/profile'>
                <div className='bc-title-plain' style={{ cursor: 'pointer' }}>
                Account
                </div>
              </Link>
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <path d='M6 12L10 8L6 4' stroke='#D0D5DD' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
              <div className='bc-title'>
                {activeTab}
              </div>
            </div>
            {/* <div className='module-header-title-cont'>
              <h1>Account</h1>
              <div className='module-header-btns'>
              </div>
            </div> */}
          </div>
        </Grid>
        <Grid item xs={12} sx={{ padding: '10px 25px 24px 25px' }}>
          <div className='screening-tabs-container'>
            <div className='screening-tabs-inner'>
              <div className={`screening-tab-btn${activeTab === 'Profile' ? '-selected' : ''}`} onClick={() => handleTabChange('Profile')}>
                {activeTab === 'Profile' ? (
                  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                    <path d='M15 15.75C15 14.7033 15 14.18 14.8708 13.7541C14.58 12.7953 13.8297 12.045 12.8709 11.7542C12.445 11.625 11.9217 11.625 10.875 11.625H7.125C6.07833 11.625 5.55499 11.625 5.12914 11.7542C4.17034 12.045 3.42003 12.7953 3.12918 13.7541C3 14.18 3 14.7033 3 15.75M12.375 5.625C12.375 7.48896 10.864 9 9 9C7.13604 9 5.625 7.48896 5.625 5.625C5.625 3.76104 7.13604 2.25 9 2.25C10.864 2.25 12.375 3.76104 12.375 5.625Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                ) : (
                  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                    <path d='M15 15.75C15 14.7033 15 14.18 14.8708 13.7541C14.58 12.7953 13.8297 12.045 12.8709 11.7542C12.445 11.625 11.9217 11.625 10.875 11.625H7.125C6.07833 11.625 5.55499 11.625 5.12914 11.7542C4.17034 12.045 3.42003 12.7953 3.12918 13.7541C3 14.18 3 14.7033 3 15.75M12.375 5.625C12.375 7.48896 10.864 9 9 9C7.13604 9 5.625 7.48896 5.625 5.625C5.625 3.76104 7.13604 2.25 9 2.25C10.864 2.25 12.375 3.76104 12.375 5.625Z' stroke='#BDBEC1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                )}
                <div className={`screening-tab-btn-text${activeTab === 'Profile' ? '-selected' : ''}`}>
                  Profile
                </div>
              </div>
              <div className={`screening-tab-btn${activeTab === 'Team' ? '-selected' : ''}`} onClick={() => handleTabChange('Team')}>
                {activeTab === 'Team' ? (
                  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                    <path d='M8.00001 14L7.93331 13.8999C7.47021 13.2053 7.23867 12.858 6.93274 12.6065C6.66192 12.3839 6.34985 12.2169 6.01441 12.1151C5.63551 12 5.21808 12 4.38323 12H3.46668C2.71994 12 2.34657 12 2.06136 11.8547C1.81047 11.7268 1.6065 11.5229 1.47867 11.272C1.33334 10.9868 1.33334 10.6134 1.33334 9.86667V4.13333C1.33334 3.3866 1.33334 3.01323 1.47867 2.72801C1.6065 2.47713 1.81047 2.27316 2.06136 2.14532C2.34657 2 2.71994 2 3.46668 2H3.73334C5.22682 2 5.97355 2 6.54398 2.29065C7.04575 2.54631 7.4537 2.95426 7.70936 3.45603C8.00001 4.02646 8.00001 4.77319 8.00001 6.26667M8.00001 14V6.26667M8.00001 14L8.06671 13.8999C8.52981 13.2053 8.76136 12.858 9.06728 12.6065C9.33811 12.3839 9.65017 12.2169 9.98561 12.1151C10.3645 12 10.7819 12 11.6168 12H12.5333C13.2801 12 13.6534 12 13.9387 11.8547C14.1895 11.7268 14.3935 11.5229 14.5214 11.272C14.6667 10.9868 14.6667 10.6134 14.6667 9.86667V4.13333C14.6667 3.3866 14.6667 3.01323 14.5214 2.72801C14.3935 2.47713 14.1895 2.27316 13.9387 2.14532C13.6534 2 13.2801 2 12.5333 2H12.2667C10.7732 2 10.0265 2 9.45604 2.29065C8.95427 2.54631 8.54632 2.95426 8.29066 3.45603C8.00001 4.02646 8.00001 4.77319 8.00001 6.26667' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                ) : (
                  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                    <path d='M8.00001 14L7.93331 13.8999C7.47021 13.2053 7.23867 12.858 6.93274 12.6065C6.66192 12.3839 6.34985 12.2169 6.01441 12.1151C5.63551 12 5.21808 12 4.38323 12H3.46668C2.71994 12 2.34657 12 2.06136 11.8547C1.81047 11.7268 1.6065 11.5229 1.47867 11.272C1.33334 10.9868 1.33334 10.6134 1.33334 9.86667V4.13333C1.33334 3.3866 1.33334 3.01323 1.47867 2.72801C1.6065 2.47713 1.81047 2.27316 2.06136 2.14532C2.34657 2 2.71994 2 3.46668 2H3.73334C5.22682 2 5.97355 2 6.54398 2.29065C7.04575 2.54631 7.4537 2.95426 7.70936 3.45603C8.00001 4.02646 8.00001 4.77319 8.00001 6.26667M8.00001 14V6.26667M8.00001 14L8.06671 13.8999C8.52981 13.2053 8.76136 12.858 9.06728 12.6065C9.33811 12.3839 9.65017 12.2169 9.98561 12.1151C10.3645 12 10.7819 12 11.6168 12H12.5333C13.2801 12 13.6534 12 13.9387 11.8547C14.1895 11.7268 14.3935 11.5229 14.5214 11.272C14.6667 10.9868 14.6667 10.6134 14.6667 9.86667V4.13333C14.6667 3.3866 14.6667 3.01323 14.5214 2.72801C14.3935 2.47713 14.1895 2.27316 13.9387 2.14532C13.6534 2 13.2801 2 12.5333 2H12.2667C10.7732 2 10.0265 2 9.45604 2.29065C8.95427 2.54631 8.54632 2.95426 8.29066 3.45603C8.00001 4.02646 8.00001 4.77319 8.00001 6.26667' stroke='#BDBEC1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                )}
                <div className={`screening-tab-btn-text${activeTab === 'Team' ? '-selected' : ''}`}>
                  Team
                </div>
              </div>
              {cur_user.selected_team?.attributes?.team_admin?.includes(cur_user.basics?.email) && (
                <>
                  <div className={`screening-tab-btn${activeTab === 'Affiliations' ? '-selected' : ''}`} onClick={() => handleTabChange('Affiliations')}>
                    {activeTab === 'Affiliations' ? (
                      <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                        <path d='M5.25 11.3177V16.5L8.77717 15.0891C8.85949 15.0562 8.90065 15.0397 8.94314 15.0332C8.98083 15.0274 9.01917 15.0274 9.05686 15.0332C9.09935 15.0397 9.14051 15.0562 9.22283 15.0891L12.75 16.5V11.3177M14.625 7.125C14.625 10.2316 12.1066 12.75 9 12.75C5.8934 12.75 3.375 10.2316 3.375 7.125C3.375 4.0184 5.8934 1.5 9 1.5C12.1066 1.5 14.625 4.0184 14.625 7.125Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                      </svg>
                    ) : (
                      <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                        <path d='M5.25 11.3177V16.5L8.77717 15.0891C8.85949 15.0562 8.90065 15.0397 8.94314 15.0332C8.98083 15.0274 9.01917 15.0274 9.05686 15.0332C9.09935 15.0397 9.14051 15.0562 9.22283 15.0891L12.75 16.5V11.3177M14.625 7.125C14.625 10.2316 12.1066 12.75 9 12.75C5.8934 12.75 3.375 10.2316 3.375 7.125C3.375 4.0184 5.8934 1.5 9 1.5C12.1066 1.5 14.625 4.0184 14.625 7.125Z' stroke='#BDBEC1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                      </svg>
                    )}
                    <div className={`screening-tab-btn-text${activeTab === 'Affiliations' ? '-selected' : ''}`}>
                      Affiliations
                    </div>
                  </div>
                  <div className={`screening-tab-btn${activeTab === 'Plans' ? '-selected' : ''}`} onClick={() => handleTabChange('Plans')}>
                    {activeTab === 'Plans' ? (
                      <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                        <g clipPath='url(#clip0_4640_25133)'>
                          <path d='M11.9533 11.9533C14.5202 11.6096 16.5 9.41101 16.5 6.75C16.5 3.8505 14.1495 1.5 11.25 1.5C8.58899 1.5 6.39037 3.47975 6.0467 6.0467M12 11.25C12 14.1495 9.6495 16.5 6.75 16.5C3.8505 16.5 1.5 14.1495 1.5 11.25C1.5 8.3505 3.8505 6 6.75 6C9.6495 6 12 8.3505 12 11.25Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                        </g>
                        <defs>
                          <clipPath id='clip0_4640_25133'>
                            <rect width='18' height='18' fill='white'/>
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                        <g clipPath='url(#clip0_4640_24978)'>
                          <path d='M11.9533 11.9533C14.5202 11.6096 16.5 9.41101 16.5 6.75C16.5 3.8505 14.1495 1.5 11.25 1.5C8.58899 1.5 6.39037 3.47975 6.0467 6.0467M12 11.25C12 14.1495 9.6495 16.5 6.75 16.5C3.8505 16.5 1.5 14.1495 1.5 11.25C1.5 8.3505 3.8505 6 6.75 6C9.6495 6 12 8.3505 12 11.25Z' stroke='#BDBEC1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                        </g>
                        <defs>
                          <clipPath id='clip0_4640_24978'>
                            <rect width='18' height='18' fill='white'/>
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                    <div className={`screening-tab-btn-text${activeTab === 'Plans' ? '-selected' : ''}`}>
                      Plans
                    </div>
                  </div>
                  <div className={`screening-tab-btn${activeTab === 'Billing' ? '-selected' : ''}`} onClick={() => handleTabChange('Billing')}>
                    {activeTab === 'Billing' ? (
                      <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                        <path d='M16.5 7.5H1.5M1.5 6.15L1.5 11.85C1.5 12.6901 1.5 13.1101 1.66349 13.431C1.8073 13.7132 2.03677 13.9427 2.31901 14.0865C2.63988 14.25 3.05992 14.25 3.9 14.25L14.1 14.25C14.9401 14.25 15.3601 14.25 15.681 14.0865C15.9632 13.9427 16.1927 13.7132 16.3365 13.431C16.5 13.1101 16.5 12.6901 16.5 11.85V6.15C16.5 5.30992 16.5 4.88988 16.3365 4.56902C16.1927 4.28677 15.9632 4.0573 15.681 3.91349C15.3601 3.75 14.9401 3.75 14.1 3.75L3.9 3.75C3.05992 3.75 2.63988 3.75 2.31901 3.91349C2.03677 4.0573 1.8073 4.28677 1.66349 4.56901C1.5 4.88988 1.5 5.30992 1.5 6.15Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                      </svg>
                    ) : (
                      <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                        <path d='M16.5 7.5H1.5M1.5 6.15L1.5 11.85C1.5 12.6901 1.5 13.1101 1.66349 13.431C1.8073 13.7132 2.03677 13.9427 2.31901 14.0865C2.63988 14.25 3.05992 14.25 3.9 14.25L14.1 14.25C14.9401 14.25 15.3601 14.25 15.681 14.0865C15.9632 13.9427 16.1927 13.7132 16.3365 13.431C16.5 13.1101 16.5 12.6901 16.5 11.85V6.15C16.5 5.30992 16.5 4.88988 16.3365 4.56902C16.1927 4.28677 15.9632 4.0573 15.681 3.91349C15.3601 3.75 14.9401 3.75 14.1 3.75L3.9 3.75C3.05992 3.75 2.63988 3.75 2.31901 3.91349C2.03677 4.0573 1.8073 4.28677 1.66349 4.56901C1.5 4.88988 1.5 5.30992 1.5 6.15Z' stroke='#BDBEC1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                      </svg>
                    )}
                    <div className={`screening-tab-btn-text${activeTab === 'Billing' ? '-selected' : ''}`}>
                      Billing
                    </div>
                  </div>
                </>
              )}
              {/* <div className={`screening-tab-btn${activeTab === 'Notifications' ? '-selected' : ''}`} onClick={() => handleTabChange('Notifications')}>
                <div className={`screening-tab-btn-text${activeTab === 'Notifications' ? '-selected' : ''}`}>
              Notifications
                </div>
              </div> */}
            </div>
          </div>
        </Grid>
        <div className='HomeDashboard-container'>
          {activeTab === 'Profile' && (
            <ProfileContent curUser={cur_user} />
          )}
          {activeTab === 'Team' && (
            <TeamContent cusId={customerId} cur_user={cur_user} handleTabChange={handleTabChange} />
          )}
          {activeTab === 'Plans' && (
            <PlansOverview cur_user={cur_user} team={cur_user.selected_team} handleTabChange={handleTabChange} />
          )}
          {activeTab === 'Billing' && (
            <BillingOverview cusId={customerId} cur_user={cur_user} team={cur_user.selected_team} handleTabChange={handleTabChange} />
          )}
          {activeTab === 'Affiliations' && (
            <Affiliations cur_user={cur_user} />
          )}
          {activeTab === 'Notifications' && (
            <h1>Notifications to be built</h1>
          )}
        </div>
      </Grid>
    </section>
  );
};

export default ProfileHome;
